import Style from "../components/Style.module.css"
import React, {useState} from "react";
import SearchIcon from '@mui/icons-material/Search';
import SearchOffSharpIcon from '@mui/icons-material/SearchOffSharp';
import GamesListFilter from "./GamesListFilter";
import {useTranslation} from "react-i18next";

function PageTipsGamesList({allGames, finished, filterGameTypes, children}) {
    const [filterOpened, setFilterOpened] = useState(false)
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'pageTipsGamesList'});

    function openFilter() {
        setFilterOpened(true)
    }

    function closeFilter(event) {
        setFilterOpened(false)
        filterGameTypes(true, false, false, false)
        event.cancelBubble = true;
        if (event.stopPropagation) event.stopPropagation();
    }

    return (
        <div className={Style.pageTips}>
            <div
                className={`${Style.pageTipsHeaderOnly} ${Style.h5Heading}`}>
                <div>{t('finishedGames')} - <span style={{color: "green"}}>{finished}</span> (<span style={{color: "red"}}>{allGames}</span>)
                </div>
                <div>
                    {
                        filterOpened ?
                            <SearchOffSharpIcon style={{width: "24px", height: "24px", alignSelf: "right"}}
                                           onClick={closeFilter}/>
                            :
                            <SearchIcon style={{width: "24px", height: "24px", alignSelf: "right"}}
                                                   onClick={openFilter}/>
                    }

                </div>

            </div>
            {filterOpened &&
                <GamesListFilter filter={filterGameTypes}></GamesListFilter>}
        </div>

    )
}

export default PageTipsGamesList